import { latestDataPointGroupUpdateDate, latestDataPointGroupUpdateDateTime } from '../../DataPointGroup';
import { decayedLimit, isDecayed } from '../../util';
import { AmountSumTableItem, AmountSumTableItemProps } from './Table';
import { NoteReceivable } from '../../generated/graphql';

interface NoteReceivableSumTableItemProps
  extends Pick<
    AmountSumTableItemProps,
    'amount' | 'className' | 'subtitle' | 'withChevron' | 'motionProps' | 'contentPrefix'
  > {
  itemTitle?: string;
  noteReceivable: NoteReceivable;
  onItemClicked?: (a: { noteReceivable: NoteReceivable }) => void;
}

export const NoteReceivableSumTableItem = ({
  noteReceivable,
  onItemClicked,
  ...props
}: NoteReceivableSumTableItemProps) => {
  return (
    <AmountSumTableItem
      contentPrefix={props.contentPrefix}
      motionProps={props.motionProps}
      key={noteReceivable.id}
      title={props.itemTitle ?? noteReceivable.name}
      dataTestID={noteReceivable.name}
      withChevron={props.withChevron ?? !!onItemClicked}
      amount={noteReceivable.ownedValue}
      className={props.className}
      onClick={() => onItemClicked?.({ noteReceivable })}
      lastUpdated={latestDataPointGroupUpdateDateTime(noteReceivable.value)}
      onKeyDown={(e) => e.key === 'Enter' && onItemClicked?.({ noteReceivable })}
      decayed={isDecayed(latestDataPointGroupUpdateDate(noteReceivable.value), decayedLimit.NoteReceivable)}
    />
  );
};
